import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ReactGA from 'react-ga';
import config from 'config';
import { App } from './App';
import { userConstants } from './_constants';
import { history, store } from './_helpers';
import { setUnauthorizedHandler } from './_services';
import { authenticationActions } from './_slices/authentication.slice';

if (config.gaMeasurementId) {
  ReactGA.initialize(config.gaMeasurementId);
  ReactGA.pageview(window.location.pathname + window.location.search);
}

setUnauthorizedHandler(() => {
  store.dispatch(authenticationActions.logout());
  store.dispatch({ type: userConstants.LOGOUT });
  history.push('/login');
});

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
